import React, { useState } from "react";
import { PieChart, Pie, Tooltip, ResponsiveContainer, Cell, Legend } from "recharts";
import { Filter } from "lucide-react";
import { SideDrawer } from "../../../component/SideDrawer/SideDrawer"; // adjust path
import DateRangePicker from "../DateRangePicker";

const COLORS = ["#0088FE", "#82ca9d", "#FFBB28", "#FF8042", "#A569BD", "#FF6384", "#36A2EB"];

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, value }) => {
  const radius = innerRadius + (outerRadius - innerRadius) / 2;
  const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
  const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={11}
      fontWeight="bold"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

export default function MyDonutChart({ invoice, setStartDate, setEndDate }) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  //  group by name (customer)
  const groupByName = (invoices) => {
    return invoices.reduce((acc, item) => {
      const person = item?.createBy?.name || "Unknown";
      const total = parseFloat(item.total) || 0;
      acc[person] = (acc[person] || 0) + total;
      return acc;
    }, {});
  };

  const nameTotals = groupByName(invoice);

  // format data for recharts
  const donutData = Object.entries(nameTotals).map(([name, value]) => ({
    name,
    value,
  }));

  return (
    <div style={{ width: "100%", height: 320 }} className="bg-white p-5">
      <div className="flex flex-row justify-between items-center">
        <h5 className="md:text-[20px] text-[20px] font-bold text-gray-800">
          Sales by Customer
        </h5>
        {/* <Filter
          className="cursor-pointer"
          onClick={() => setIsDrawerOpen(true)}
        /> */}
      </div>

      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={donutData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={50}
            outerRadius={90}
            labelLine={false}
            label={renderCustomizedLabel}
          >
            {donutData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name) => [
              new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR",
              }).format(value),
              name,
            ]}
          />
          <Legend
            content={({ payload }) => (
              <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 mt-2 text-xs md:text-sm mb-5">
                {payload.map((entry, index) => (
                  <div key={`item-${index}`} className="flex items-center">
                    <span
                      className="w-3 h-3 inline-block mr-2 rounded"
                      style={{ backgroundColor: entry.color }}
                    />
                    <span className="truncate max-w-[80px] md:max-w-[150px]">{entry.value}</span>
                  </div>
                ))}
              </div>
            )}
          />
        </PieChart>
      </ResponsiveContainer>

      <SideDrawer
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Filter Options"
        customWidth
      >
        <div className="px-12">
          <DateRangePicker
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setIsDrawerOpen={setIsDrawerOpen}
          />
        </div>
      </SideDrawer>
    </div>
  );
}
